import React from 'react';
import { Text } from 'react-native';
import { iOSUIKit } from 'react-native-typography';
import responsive from '../../responsive';
import mergeStyles from '../../util/mergeStyles';
const iOSUIKitMap = {
    paragraph: 'body',
    subhead: 'subhead',
    subheadEmphasized: 'subheadEmphasized',
    footnote: 'footnote',
    footnoteEmphasized: 'footnoteEmphasized',
};
function parseType(props) {
    const [typeSize] = Object
        .keys(props)
        .filter(key => iOSUIKitMap[key]);
    return typeSize;
}
const S = {
    center: {
        textAlign: 'center',
    },
};
const Type = (props) => {
    const { children } = props;
    const type = parseType(props);
    const mappedType = iOSUIKit[iOSUIKitMap[type]];
    return (<Text {...props} style={mergeStyles(props, mappedType, [S.center, !responsive.device.isWeb])}>
      {children}
    </Text>);
};
export default Type;
//# sourceMappingURL=Text.js.map